import { style } from "@vanilla-extract/css";
import { responsiveContainer } from "@huub-web/ui/utils/responsive";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { recipe } from "@vanilla-extract/recipes";

const BREAKPOINT = 600;

export const houseCardStyle = recipe({
  base: {
    aspectRatio: "4/3",
    ...responsiveContainer({
      [BREAKPOINT]: {
        aspectRatio: "16/9",
      },
      800: {
        aspectRatio: "16/7",
      },
    }),
  },
  variants: {},
});

export const trailingGridStyle = recipe({
  base: {
    gridTemplateColumns: `repeat(1, 1fr)`,
    gap: 0,
  },
  variants: {
    hasTwoColumns: {
      true: {
        ...responsiveContainer({
          [BREAKPOINT]: {
            gap: theme.spacings.s,
            gridTemplateColumns: `repeat(2, 1fr)`,
          },
        }),
      },
    },
  },
});

export const trailingMainCardContentStyle = recipe({
  base: {
    padding: theme.spacings.s,
  },
  variants: {
    // hasSibling: {
    //   false: {
    //     gridColumn: "span 2 / span 2",
    //   },
    // },
  },
});

export const trailingCardStyle = style({
  borderRadius: theme.borderRadiuses.s,
});

export const trailingCardContentStyle = style({
  justifyContent: "flex-end",
});

export const chanceCardStyle = style({
  display: "none",
  ...responsiveContainer({
    [BREAKPOINT]: {
      display: "flex",
    },
  }),
});

export const chanceCardBottomStyle = style({
  ...responsiveContainer({
    [BREAKPOINT]: {
      display: "none",
    },
  }),
});
